import React from "react";
import LoginComponent from "../components/Login/LoginComponent";

const Login = () => {
  return <LoginComponent />;
};

export default Login;
